import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown-content',
  template: `
    <div [class.dropdown__content--pull-left]="pullLeft" class="dropdown__content">
      <ng-content></ng-content>
    </div>
  `,
})
export class DropdownContentComponent {
  @Input() pullLeft?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/dropdown-content.component.ts